import { Trans } from '@lingui/react/macro';

import { LinkButton } from '@/components/buttons';
import InstantSearchInput from '@/components/InstantSearchInput';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { ROUTES } from '@/router';

const UsersListHeader = () => {
  return (
    <div className="flex items-center justify-between">
      <LinkButton variant="primary" to={ROUTES.userInvite.path}>
        <Trans>Invite User</Trans>
      </LinkButton>
      <div className="flex items-center gap-2">
        <PendoPlaceholder />
        <InstantSearchInput />
      </div>
    </div>
  );
};

export default UsersListHeader;
